<template>
  <transition name="modal" v-on:after-enter="afterEnter" appear>
    <div :class="overlayClassModifiers">
      <div class="modal__wrapper">
        <div class="modal__body" :class="bodyClass">
          <div v-if="hasHeader()" class="modal__header" :class="headerClass">
            <slot name="header"></slot>
            <button
              v-show="closeButton"
              class="modal__close"
              @mousedown.prevent
              @click.prevent="close"
            ></button>
          </div>
          <div
            class="modal__content"
            v-click-outside="onClickOutside"
            :class="[classModifier, { 'modal__content--with-footer': hasFooter() }]"
          >
            <slot name="content"></slot>
          </div>
          <div v-if="hasFooter()" class="modal__footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script src="./modal.js"></script>
<style src="./modal.scss" lang="scss"></style>
